import env from '@ludovicm67/react-dotenv';

// There are two ENV Variables for these two feature flags for backwards compatibility reasons. Once
// the "FEATURE_FLAG" versions of these are in each environment, we can remove the "ENABLE" versions

const queryParamsEnabled = env?.REACT_APP_ENABLE_QUERY_PARAMS === 'true' || env.REACT_APP_FEATURE_FLAG_QUERY_PARAMS === 'true';

const navigationEnabled = env?.['REACT_APP_FEATURE_FLAG_NAVIGATION'] === 'true';
const MaintenanceModeEnabled = env?.['REACT_APP_FEATURE_FLAG_MAINTENANCE_MODE'] === 'true';

export { queryParamsEnabled, navigationEnabled, MaintenanceModeEnabled };
